import './cs.scss';
import React, {useMemo, useRef, useState} from 'react';
import {Button, Tag} from "antd";
import dayjs from "dayjs";
import {defaultCSSearchParam, stateList} from "../../shared/utils/defaultData";
import CsEditModal from "./CsEditModal";
import {buildUrl} from "../../shared/utils/net";
import TablePage from "../../pages/tablePage/TablePage";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";
import SearchParams from "../../shared/components/common/SearchParams";
import EmailSendModal from "../../shared/components/modal/EmailSendModal";

const Cs = () => {
    defaultCSSearchParam.begin = dayjs().subtract(7, 'day').startOf('day').unix();
    defaultCSSearchParam.end = dayjs().endOf('day').unix();

    const [searchParam, setSearchParam] = React.useState(defaultCSSearchParam);
    const [url, setUrl] = useState(buildUrl('cs', searchParam));
    const [rowData, setRowData] = useState({});
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [emailList, setEmailList] = useState([]);
    const [csnList, setCsnList] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const refreshRef = useRef(null);

    const handleSearch = () => {
        setUrl(buildUrl('cs', searchParam));
    }

    const handleSetSearchParam = (key, value) => {
        setSearchParam(prevState => ({
            ...prevState,
            [key]: value
        }));
    }

    const columns = useMemo(() => ([
        {
            title: 'No.',
            dataIndex: 'csn',
            key: 'csn',
            width: 180,
        },
        {
            title: '접수일',
            dataIndex: 'requested',
            render: (requested) => dayjs.unix(requested).format('YYYY-MM-DD HH:mm'),
            width: 170,
            sorter: (a, b) => a.requested - b.requested,
        },
        {
            title: '답변일',
            dataIndex: 'replied',
            render: (replied) => replied === 0 ? '' : dayjs.unix(replied).format('YYYY-MM-DD HH:mm'),
            width: 170,
            sorter: (a, b) => a.replied - b.replied,
        },
        {
            title: '디바이스',
            dataIndex: 'device',
        },
        {
            title: 'OS',
            dataIndex: 'os',
        },
        {
            title: 'PID',
            dataIndex: 'pid',
            width: 180,
            search: true,
        },
        {
            title: '닉네임',
            dataIndex: 'name',
            width: 180,
            search: true,
        },
        {
            title: 'E-Mail',
            dataIndex: 'email',
        },
        {
            title: '문의 유형',
            dataIndex: 'type',
            width: 150,
            render: (_, {type}) => {
                let color, text;
                switch (type) {
                    case 0:
                        color = 'cyan';
                        text = '계정';
                        break;
                    case 1:
                        color = 'green';
                        text = '버그';
                        break;
                    case 2:
                        color = 'blue';
                        text = '결제';
                        break;
                    case 3:
                        color = 'purple';
                        text = '기타';
                        break;
                    default:
                        color = 'lightgray';
                        text = 'Unknown';
                }
                return <Tag color={color}>{text}</Tag>;
            },
            filters: [
                {text: '계정', value: 0},
                {text: '버그', value: 1},
                {text: '결제', value: 2},
                {text: '기타', value: 3},
            ],
        },
        {
            title: '상태',
            dataIndex: 'state',
            width: 150,
            render: (_, {state}) => (
                <Tag color={stateList[state].color}>
                    {stateList[state].text}
                </Tag>
            ),
            filters: stateList,
            onFilter: (value, record) => record.state === value,
        },
        {
            title: '국가',
            dataIndex: 'region',
            width: 80
        },
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid}/>,
        },
    ]), []);

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setEmailList(selectedRows.map(row => row.email));
            setCsnList(selectedRows.map(row => row.csn));
        }
    };

    const handleSetEmailModalOpen = (open) => {
        setEmailModalOpen(open);
        if (!open && refreshRef.current) {
            refreshRef.current();
            setSelectedRowKeys([]);
            setEmailList([]);
            setCsnList([]);
        }
    }

    const props = {
        columns,
        rowData,
        setRowData,
        refreshRef,
        url,
        modal: CsEditModal,
        pageSize: 50,
        rowSelection,
    }

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchParams
                    searchParam={searchParam}
                    handleSetSearchParam={handleSetSearchParam}
                    handleSearch={handleSearch}
                />
                <Button
                    type="primary"
                    onClick={() => setEmailModalOpen(true)}
                    disabled={emailList.length === 0}
                    style={{marginBottom: '10px', marginRight: '10px', minWidth: '120px'}}
                >
                    그룹 답장
                </Button>
            </div>

            <TablePage {...props}/>
            <EmailSendModal
                emailModalOpen={emailModalOpen}
                setEmailModalOpen={handleSetEmailModalOpen}
                emailList={emailList}
                csnList={csnList}
            />
        </div>
    );
};

export default Cs;